

























import { Component, Vue } from 'vue-property-decorator';
import { PermissionDTO, RoleDTO } from '@/api';
import { rolesModule } from '@/store';
import services from '@/services';
import IconTimes from '@/assets/icons/times.svg';

@Component({
  name: 'users-edit-window',
  components: { IconTimes },
})
export default class RolePermission extends Vue {
  visible = false;

  role: RoleDTO | null = null;

  permissions: string[] = [];

  permissionsList: PermissionDTO[] = [];

  created() {
    services.userService().userEndpointGetAllPermissions()
      .then(r => r.data)
      .then((permissions) => {
        this.permissionsList = permissions;
      });
  }

  open(role: RoleDTO) {
    this.role = role;
    this.permissions = (role.permissions || []).map<string>(p => p.id as string);
    this.visible = true;
  }

  close() {
    this.visible = false;
  }

  async submit() {
    if (this.role && this.role.id != null) {
      const permissions = this.permissionsList
        .filter(p => this.permissions.includes(p.id as string));
      rolesModule.saveRolePermissions({ roleId: this.role.id, permissions })
        .then(() => this.close());
    }
  }
}
